// LSU's undergraduate majors (#2652, round 2). Read on 2026-10-01 from the
// official 2026-2027 General Catalog's All Degree Programs page
// (catalog.lsu.edu, catoid=35, navoid=3400), fetched by the lane lead in a
// headless browser because the catalog answers plain requests with an AWS
// WAF challenge. Every line under a "Major" heading is kept, grouped by the
// college the catalog lists it under, with the degree as the catalog writes
// it (B.S., BS, B.Arch., B.S.Ch.E., ...; "B.S" for Agricultural & Extension
// Education is the catalog's spelling). Folded or dropped: the "(3+3
// Pre-Law Program)" copies of Humanities & Social Sciences majors (the same
// degree on a law-school track), repeat listings of Plant & Soil Systems
// under several departments, the "CES." code after Coastal Environmental
// Science's B.S., and LSU Online's Architecture M.S. The catalog lists
// "African & African American Studies" once without a degree; its 3+3 line
// names the B.A., used here. Left out: University College's undecided and
// pre-professional programs, minors, and graduate programs.
const majors = {
    "slug": "louisiana-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in LSU's official 2026-2027 General Catalog, grouped by the college that offers it, with the degree it leads to. Minors, pre-professional programs, graduate programs and online-only listings are left out.",
    "groups": [
        {
            "name": "College of Agriculture",
            "source": {
                "label": "LSU 2026-2027 General Catalog, All Degree Programs",
                "url": "https://catalog.lsu.edu/content.php?catoid=35&navoid=3400"
            },
            "majors": [
                {
                    "name": "Agricultural & Extension Education",
                    "degree": "B.S"
                },
                {
                    "name": "Agricultural Business",
                    "degree": "B.S."
                },
                {
                    "name": "Plant & Soil Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Textiles, Apparel & Merchandising",
                    "degree": "B.S."
                },
                {
                    "name": "Animal Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Nutrition & Food Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Management Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Natural Resource Ecology & Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Art & Design",
            "source": {
                "label": "LSU 2026-2027 General Catalog, All Degree Programs",
                "url": "https://catalog.lsu.edu/content.php?catoid=35&navoid=3400"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Arch."
                },
                {
                    "name": "Art and Design",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Interior Design",
                    "degree": "B.I.D."
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "B.L.A."
                }
            ]
        },
        {
            "name": "E. J. Ourso College of Business",
            "source": {
                "label": "LSU 2026-2027 General Catalog, All Degree Programs",
                "url": "https://catalog.lsu.edu/content.php?catoid=35&navoid=3400"
            },
            "majors": [
                {
                    "name": "General Business",
                    "degree": "B.S."
                },
                {
                    "name": "Business Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "International Trade and Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BS"
                },
                {
                    "name": "Information Systems & Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of the Coast & Environment",
            "source": {
                "label": "LSU 2026-2027 General Catalog, All Degree Programs",
                "url": "https://catalog.lsu.edu/content.php?catoid=35&navoid=3400"
            },
            "majors": [
                {
                    "name": "Coastal Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Coastal Meteorology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "LSU 2026-2027 General Catalog, All Degree Programs",
                "url": "https://catalog.lsu.edu/content.php?catoid=35&navoid=3400"
            },
            "majors": [
                {
                    "name": "Biological Engineering",
                    "degree": "B.S.B.E."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S.Ch.E."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S.C.E."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S.Ev.E."
                },
                {
                    "name": "Construction Management",
                    "degree": "B.S.C.M."
                },
                {
                    "name": "Fire and Emergency Services Administration",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S.Comp.E."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.E.E."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S.I.E."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.M.E."
                },
                {
                    "name": "Petroleum Engineering",
                    "degree": "B.S.P.E."
                }
            ]
        },
        {
            "name": "Roger Hadfield Ogden Honors College",
            "source": {
                "label": "LSU 2026-2027 General Catalog, All Degree Programs",
                "url": "https://catalog.lsu.edu/content.php?catoid=35&navoid=3400"
            },
            "majors": [
                {
                    "name": "Honors Traditions in Critical Thought and Scholarship",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Human Sciences and Education",
            "source": {
                "label": "LSU 2026-2027 General Catalog, All Degree Programs",
                "url": "https://catalog.lsu.edu/content.php?catoid=35&navoid=3400"
            },
            "majors": [
                {
                    "name": "Early Childhood Education",
                    "degree": "B.S."
                },
                {
                    "name": "Elementary Grades Education",
                    "degree": "B.S."
                },
                {
                    "name": "Exceptional Educator: Grades 1-5",
                    "degree": "B.S."
                },
                {
                    "name": "Kinesiology",
                    "degree": "B.S."
                },
                {
                    "name": "Sport Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Leadership & Human Resource Development",
                    "degree": "B.S."
                },
                {
                    "name": "Human Development & Family Science",
                    "degree": "B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        },
        {
            "name": "College of Humanities & Social Sciences",
            "source": {
                "label": "LSU 2026-2027 General Catalog, All Degree Programs",
                "url": "https://catalog.lsu.edu/content.php?catoid=35&navoid=3400"
            },
            "majors": [
                {
                    "name": "African & African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Disorders",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.S."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.I.S."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Liberal Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Screen Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Manship School of Mass Communication",
            "source": {
                "label": "LSU 2026-2027 General Catalog, All Degree Programs",
                "url": "https://catalog.lsu.edu/content.php?catoid=35&navoid=3400"
            },
            "majors": [
                {
                    "name": "Mass Communication",
                    "degree": "B.A.M.C."
                }
            ]
        },
        {
            "name": "College of Music & Dramatic Arts",
            "source": {
                "label": "LSU 2026-2027 General Catalog, All Degree Programs",
                "url": "https://catalog.lsu.edu/content.php?catoid=35&navoid=3400"
            },
            "majors": [
                {
                    "name": "Music Education",
                    "degree": "B.M.E."
                },
                {
                    "name": "Music Therapy",
                    "degree": "B.M.T."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.M."
                },
                {
                    "name": "Film and Television",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "LSU 2026-2027 General Catalog, All Degree Programs",
                "url": "https://catalog.lsu.edu/content.php?catoid=35&navoid=3400"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "B.S.Geol."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
